module.exports = __webpack_public_path__ + "static/media/badgeOff_118.76167266.png";